import React from 'react';
import { Skeleton, Space } from 'antd';

const AbandonedBusinessLoadingScreen: React.FC = () => (
  <Space direction='vertical' size={24} style={{ width: '100%' }}>
    <Skeleton active paragraph={{ rows: 2 }} title={{ width: '60%' }} />
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      {[1, 2, 3, 4].map(i => (
        <div
          key={i}
          style={{
            display: 'flex',
            gap: 16,
            alignItems: 'center',
            padding: '12px 0',
          }}
        >
          <Skeleton.Avatar active shape='square' size={72} style={{ borderRadius: 12 }} />
          <Skeleton
            active
            paragraph={{ rows: 1 }}
            title={{ width: '40%' }}
            style={{ flex: 1, margin: 0 }}
          />
        </div>
      ))}
    </Space>
  </Space>
);

export default AbandonedBusinessLoadingScreen;

